import React from 'react';
import get from 'lodash/get';
import { message } from 'antd';
import { ARCHIVE_TASK_LIMIT } from './types';
import { post } from 'appJS/utils/fetch';
import styles from './index.module.css';
import * as translations from './strings';
import { getLangKey } from 'jsModels/Application';
import { items } from './items';

const strings = translations[getLangKey()];

type Props = {
  isMinColumns: boolean;
  unfilteredTaskCount: number;
  getArchive: (tasksToArchive: any, columnId: any) => void;
  handleAddColumn: () => void;
  dispatch: (param: { type: string; payload: { [key: string]: any } }) => void;
  showEditMode: () => void;
  cards: any[];
  projectId: number;
  column: { id: number };
  toggleArchiveModal: () => void;
  toggleDeleteModal: () => void;
  getColumnToDelete: (columnId: number) => void;
  archiveDisabled: boolean;
  archiveAllowed: boolean;
  unreadCommentsAllowed: boolean;
  archiveStage: string;
  setSelectedTaskList: (taskList: string[]) => void;
  selectedTaskList: string[];
};

const MenuLabel = ({ icon, text }) => (
  <div className={styles.actionBox}>
    {icon}
    {text && <span className={styles.actionText}>{text}</span>}
  </div>
);

export const menuItems = ({
  isMinColumns,
  unfilteredTaskCount,
  getArchive,
  handleAddColumn,
  dispatch,
  showEditMode,
  cards,
  projectId,
  column,
  toggleArchiveModal,
  toggleDeleteModal,
  getColumnToDelete,
  archiveDisabled,
  archiveAllowed,
  unreadCommentsAllowed,
  archiveStage,
  setSelectedTaskList,
  selectedTaskList
}: Props) => {
  const getDeleteColumnProps = () => {
    let disabled = true;
    let title = strings.containsTaks;
    if (isMinColumns) title = strings.minColumns;
    else if (unfilteredTaskCount === 0) return { disabled: false };

    return { disabled, title };
  };

  const handleAddTask = () => {
    setTimeout(
      () =>
        dispatch({
          type: 'CREATE_TASK',
          payload: { columnId: column.id }
        }),
      300
    );
  };

  const handleMarkAllAsRead = () => {
    const tasksToMarkAsRead = cards.map(card => get(card, 'props.data.id'));
    post(`/projects/${projectId}/mark_tasks_as_read`, {
      task_ids: tasksToMarkAsRead
    })
      .then(response => {
        message.success(strings.markAllAsReadSuccess);
      })
      .catch(error => {
        message.error(strings.markAllAsReadFailure);
      });
  };

  const handleArchiveAll = () => {
    toggleArchiveModal();
    const tasksToArchive = cards
      .map(card => get(card, 'props.data.id'))
      .slice(0, ARCHIVE_TASK_LIMIT);
    getArchive(tasksToArchive, column.id);
  };

  const handleDeleteColumn = () => {
    toggleDeleteModal();
    getColumnToDelete(column.id);
  };

  const cardIds = cards.map(card => get(card, 'props.data.id')?.toString());

  const allSelected = !!(
    selectedTaskList.length &&
    cardIds.length &&
    cardIds.filter(id => selectedTaskList.includes(id)).length ===
      cardIds.length
  );

  const menuItems = items({
    handlers: {
      addTask: handleAddTask,
      addColumn: handleAddColumn,
      renameColumn: showEditMode,
      markAllAsRead: handleMarkAllAsRead,
      archiveAll: handleArchiveAll,
      deleteColumn: handleDeleteColumn,
      selectAll: () => setSelectedTaskList(allSelected ? [] : cardIds)
    },
    archiveStage,
    cards,
    archiveAllowed,
    unreadCommentsAllowed,
    archiveDisabled,
    deleteProps: getDeleteColumnProps(),
    allSelected
  });

  return menuItems
    .filter(({ hide = false }) => !hide)
    .map(({ key, label, icon, onClick, title, disabled }) => ({
      key,
      label: <MenuLabel icon={icon} text={label} />,
      onClick,
      className: styles.dropDownItem,
      disabled,
      title
    }));
};
